var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 22.5739L23.3212 18.9361L17.125 15.2982V22.5739Z",
    fill: "url(#paint0_linear_2061_2913)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6435 0C9.18836 0 0.714844 8.47351 0.714844 18.9286C0.714844 29.3837 9.18836 37.8572 19.6435 37.8572C30.0986 37.8572 38.5721 29.3837 38.5721 18.9286C38.5721 8.47351 30.0986 0 19.6435 0ZM29.1078 22.3151C29.1078 25.5758 25.847 25.5758 25.847 25.5758H13.4399C10.1792 25.5758 10.1792 22.3151 10.1792 22.3151V15.5496C10.1792 12.2888 13.4399 12.2888 13.4399 12.2888H25.847C29.1078 12.2888 29.1078 15.5496 29.1078 15.5496V22.3151Z",
    fill: "url(#paint1_linear_2061_2913)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2061_2913",
    x1: 19.8819,
    y1: 15.7787,
    x2: 23.3192,
    y2: 17.6389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A94904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2061_2913",
    x1: 17.5591,
    y1: 2.5,
    x2: 36.9003,
    y2: 14.7908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A94904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.73228e33017d9dc79db68943e85bac88.svg";
export { ForwardRef as ReactComponent };